<template>
  <div class="home-view">
    <Navbar :nav="nav" @navChange="nav = $event" />
    <div id="home__content" v-show="nav == 'Home'">
       <Home @navChange="nav = $event" />
    </div>
    <div id="about__content" v-show="nav == 'About'">
       <About />
    </div>
    <div id="skills__content" v-show="nav == 'Skills'">
       <Skills />
    </div>
    <div id="contact__content" v-show="nav == 'Contact'">
      <Contact :nav="nav" />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Home from '@/components/portfolio/Home.vue';
import About from '@/components/portfolio/About.vue';
import Skills from '@/components/portfolio/Skills.vue';
import Contact from '@/components/portfolio/Contact.vue';
export default {
  components: {
    Navbar,
    Home,
    About,
    Skills,
    Contact
  },
  data() {
    return {
      nav: 'Home'
    };
  },
  methods: {
    navChange(loc) {
      this.nav = loc;
    }
  }
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
body {
  width: 100vw;
  overflow: hidden;
}
.home-view {
  width: 100vw;
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  overflow-x: hidden;
}
#home__content, #about__content, #skills__content, #contact__content {
  position: relative;
  width: 100%;
  overflow-x: hidden;
  margin-left: 80px;
  padding: 10px;
}
</style>
